import axios from "axios";
export default {
    data() {
        return {
            magazzinoTipoOptions: [],
            pathResourceMagazzinoTipo: "/magazzinotipo",
        };
    },
    methods: {
        loadResourceMagazzinoTipo() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceMagazzinoTipo;
            axios.get(link)
                .then((response) => {
                    this.magazzinoTipoOptions = response.data.data.list;
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
    },
};
